<script>

import { Overlay } from '../../'

export default {
    name: 'ZLEMA',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Zero Lag Exponential Moving Average - Reduces lag in EMA',
                preset: {
                    name: 'ZLEMA $length',
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        color: '#795548'
                    }
                }
            }
        },
        use_for() { return ['ZLEMA'] },
        calc() {
            return {
                props: {
                    length: { def: 14, text: 'Length' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    // Manual ZLEMA calculation
                    let lag = Math.floor((length - 1) / 2)
                    let zlema_src = close[0] + (close[0] - (close[lag] || close[0]))
                    
                    let zlema = ema(ts(zlema_src), length)[0]
                    return zlema
                `
            }
        }
    }
}
</script>
